import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {deleteItem} from "../../../app/setters/deleteItem.js";

export const useUsunProfil = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id) => deleteItem(`/oper/profile/${id}`),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`oper_profile`),
            });
        },
        onSuccess: ({message}) => {
            toast.success(message)
        },
    });
};
